import React, { PropsWithChildren, useMemo } from 'react';
import Axios from 'axios';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { ClientContext } from '../clientContext/ClientContext';

import { responseFailureInterceptor, responseSuccessInterceptor } from './interceptors/responseInterceptors';
import { requestInterceptor } from './interceptors/requestInterceptors';

import { config } from '@percent/grants-nomination-form/config/config';

const queryClient = new QueryClient({});

export const ClientContextController = ({ children }: PropsWithChildren) => {
  const { i18n } = useTranslation();

  const axios = useMemo(() => {
    const axios = Axios.create({
      baseURL: `${config.urls.api}`,
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language,
      },
    });

    axios.interceptors.request.use(requestInterceptor);
    axios.interceptors.response.use(responseSuccessInterceptor, responseFailureInterceptor);

    return axios;
  }, [i18n.language]);

  return (
    <ClientContext.Provider value={axios}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ClientContext.Provider>
  );
};
